import {takeLatest, put, all, call} from 'redux-saga/effects';
import {successToast} from '../actions';
import * as AC from '../actions/actionTypes';
import {
  addSupervisorApi,
  deleteSupervisorApi,
  editSupervisorApi,
  getSupervisorDetailsApi,
  getSupervisorsApi,
} from '../api/supervisors.service';
import history from '../routes/history';
import {errorHandler} from '../utils/errorHandler';

function* getSupervisorsSaga(fn) {
  try {
    const response = yield call(getSupervisorsApi, fn.filters);
    yield put({type: AC.GET_SUPERVISORS_SUCCEED, payload: response.data});
  } catch (e) {
    yield errorHandler(e, AC.GET_SUPERVISORS_FAILED);
  }
}

function* getSupervisorDetailsSaga(fn) {
  try {
    const response = yield call(getSupervisorDetailsApi, fn.id || fn.payload.id);
    yield put({type: AC.GET_SUPERVISOR_DETAILS_SUCCEED, payload: response.data});
  } catch (e) {
    yield errorHandler(e, AC.GET_SUPERVISOR_DETAILS_FAILED);
  }
}

function* addSupervisorSaga(fn) {
  try {
    const response = yield call(addSupervisorApi, fn.payload);
    yield put({type: AC.ADD_SUPERVISOR_SUCCEED, payload: response.data});
    yield put(successToast('Supervisor created successfully!'));
  } catch (e) {
    yield errorHandler(e, AC.ADD_SUPERVISOR_FAILED);
  }
}

function* editSupervisorSaga(fn) {
  try {
    const response = yield call(editSupervisorApi, fn.payload);
    yield put({type: AC.EDIT_SUPERVISOR_SUCCEED, payload: response.data});
    yield put(successToast('Supervisor edited successfully!'));
  } catch (e) {
    yield errorHandler(e, AC.EDIT_SUPERVISOR_FAILED);
  }
}

function* deleteSupervisorSaga(fn) {
  try {
    const response = yield call(deleteSupervisorApi, fn.id);
    yield put({type: AC.DELETE_SUPERVISOR_SUCCEED, payload: response.data});
    yield put(successToast('Supervisor deleted successfully!'));
    history.back();
  } catch (e) {
    yield errorHandler(e, AC.DELETE_SUPERVISOR_FAILED);
  }
}

function* actionWatcher() {
  yield takeLatest(
    [AC.GET_SUPERVISORS_REQUEST, AC.ADD_SUPERVISOR_SUCCEED],
    getSupervisorsSaga,
  );
  yield takeLatest(
    [AC.GET_SUPERVISOR_DETAILS_REQUEST, AC.EDIT_SUPERVISOR_SUCCEED],
    getSupervisorDetailsSaga,
  );
  yield takeLatest(AC.ADD_SUPERVISOR_REQUEST, addSupervisorSaga);
  yield takeLatest(AC.EDIT_SUPERVISOR_REQUEST, editSupervisorSaga);
  yield takeLatest(AC.DELETE_SUPERVISOR_REQUEST, deleteSupervisorSaga);
}

export default function* supervisorsSaga() {
  yield all([actionWatcher()]);
}
